import { render, staticRenderFns } from "./PromotionGrowthIcon.vue?vue&type=template&id=1c41dca9&scoped=true"
import script from "./PromotionGrowthIcon.vue?vue&type=script&lang=js"
export * from "./PromotionGrowthIcon.vue?vue&type=script&lang=js"
import style0 from "./PromotionGrowthIcon.vue?vue&type=style&index=0&id=1c41dca9&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41dca9",
  null
  
)

export default component.exports